import { Component, Inject, OnInit } from '@angular/core';
import { LicenseType } from 'app/models/signup.model';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule, NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

interface PlanDialogData {
  planName: LicenseType;
}

@Component({
  selector: 'cva-standalone-plan-selection-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    NgClass
  ],
  templateUrl: './plan-selection-dialog.component.html',
  styles: [
    `
    .fuse-confirmation-dialog-panel {
      @screen md {
        @apply w-128;
      }
      
      .mat-mdc-dialog-container {
        .mat-mdc-dialog-surface {
          padding: 0 !important;
        }
      }
    }
    .-m-16{margin:-1rem;}
    /* Hide number input arrows (spinner) */
    input.no-spinner::-webkit-outer-spin-button,
    input.no-spinner::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input.no-spinner[type='number'] {
      -moz-appearance: textfield; /* Firefox */
    }

    `,
  ],
})
export class PlanSelectionDialogComponent implements OnInit {
  LicenseType = LicenseType;
  step = 1;
  planForm: FormGroup;
  maxUsers = 500;
  userCount = 1;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<PlanSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PlanDialogData
  ) {
    this.planForm = this.fb.group({
      users: [1, [
        Validators.required,
        Validators.min(1),
        Validators.max(this.maxUsers),
        Validators.pattern(/^\d+$/)
      ]]
    });
  }


  ngOnInit() {
    if (this.data.planName === LicenseType.INDIVIDUAL) {
      this.step = 2;
    }
  }

  nextStep() {
    if (this.data.planName === LicenseType.ENTERPRISE) {
      if (this.planForm.valid) {
        this.userCount = this.planForm.value.users;
        this.step = 2;
      } else {
        this.planForm.markAllAsTouched();
      }
    } else {
      this.step = 2;
    }
  }

  previousStep() {
    this.step = 1;
  }

  confirmPlan() {
    const result = {
      plan: this.data.planName,
      users: this.data.planName === LicenseType.ENTERPRISE ? this.userCount : 1,
    };
    this.dialogRef.close(result);
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
